module.exports = __webpack_public_path__ + "img/Solutions for Singers.accc9509.jpg";